/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmployeeWorkHours/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconTimer from 'DesignSystem/Svgs/TysiaIconTimer/index'



/** @type {import('Simple/types.js').View} */
export default function EmployeeWorkHours({
  children,
  viewPath = "/App/Account/Topbar/Tabs/QuickAccess/Tab/Icon/EmployeeWorkHours",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<TysiaIconTimer
  viewPath={`${viewPath}/TysiaIconTimer`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsWhite : hovered ? dtColorsWhite : selected ? dtColorsWhite : dtColorsWhite}
/>
{children}
</React.Fragment>)
}